export default "__VITE_PUBLIC_ASSET__6d2d5f91__"